import type { DateTimeFormatter } from '../../../../core/types/formatter.js';
import type { AnyNumberScale } from '../../../../core/types/scales.js';
import { formatDateBasedOnDomain } from '../../../../core/utils/format-date-based-on-domain.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import {
  AxisIdToFormatter,
  XYChartAxisInternal,
} from '../../../types/xy-chart-internals.js';

export const handleFormatter = (
  axesConfig: XYChartAxisInternal,
  axesIdToFormatter: AxisIdToFormatter,
  scale: AnyNumberScale,
  xMousePosition: number,
  width: number,
) => {
  const correspondentToDomain = scale.invert(xMousePosition);
  const isDate = correspondentToDomain instanceof Date;
  const formatterFromConfig = safeGet(axesIdToFormatter, axesConfig.id);

  if (isDate) {
    if (axesConfig.formatter) {
      const dateTimeFormatter = formatterFromConfig as DateTimeFormatter;
      return dateTimeFormatter(new Date(correspondentToDomain));
    } else {
      return formatDateBasedOnDomain(
        correspondentToDomain,
        scale?.domain() as [Date, Date],
        width,
      );
    }
  } else {
    return formatterFromConfig(correspondentToDomain);
  }
};
